import { createContext, useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "./AuthContext";

export const MediasoupClientContext = createContext();

export const MediasoupClientProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const prevUserRef = useRef(user);
  const [sendTransport, setSendTransport] = useState(null);
  const [recvTransport, setRecvTransport] = useState(null);
  const [producerAudio, setProducerAudio] = useState(null);
  const [producerVideo, setProducerVideo] = useState(null);
  const [screenStream, setScreenStream] = useState(null); // flux de partage d’écran
  const [isScreenSharing, setIsScreenSharing] = useState(false);

  // Nettoyage automatique des ressources mediasoup lors de la deconnexion
  useEffect(() => {
    if (prevUserRef.current && !user) {
      [producerAudio, producerVideo].forEach((producer) => {
        try {
          if (producer) {
            producer.close();
            if (producer.track) producer.track.stop();
          }
        } catch (e) {}
      });
      if (sendTransport) {
        try { sendTransport.close(); } catch (e) {}
      }
      if (recvTransport) {
        try { recvTransport.close(); } catch (e) {}
      }
      if (screenStream) {
        screenStream.getTracks().forEach((track) => track.stop());
      }
      setSendTransport(null);
      setRecvTransport(null);
      setProducerAudio(null);
      setProducerVideo(null);
      setScreenStream(null);
      setIsScreenSharing(false);
    }
    prevUserRef.current = user;
  }, [user]);

  return (
    <MediasoupClientContext.Provider
      value={{
        sendTransport,
        setSendTransport,
        recvTransport,
        setRecvTransport,
        producerAudio,
        setProducerAudio,
        producerVideo,
        setProducerVideo,
        screenStream,
        setScreenStream,
        isScreenSharing,
        setIsScreenSharing,
      }}
    >
      {children}
    </MediasoupClientContext.Provider>
  );
};
